import React, { Component } from "react";
import { observer } from "mobx-react";

import { AssetVideo } from "./AssetVideo";
import { ITagDataPoint } from "./utils/ITagDataPoint";

interface IVideoPlaylistProps {
    videos?: ITagDataPoint<"video">[];
}

@observer
export class VideoPlaylist extends Component<IVideoPlaylistProps> {
    public render() {
        const { videos } = this.props;
        return (
            <>
                {videos &&
                    videos.map(_ => (
                        <AssetVideo
                            key={_.value.url}
                            src={_.value.url}
                            duration={_.value.duration}
                            startTime={_.time}
                        />
                    ))}
            </>
        );
    }
}
